import { getCategoryNAField } from 'legacy/lut/components/widgets/public/partner360/planning/helpers/getCategoryNAField'

import { isSectionSettingOn } from 'partner360/helpers/sectionSettings/isSectionSettingOn'

export const isPlanningCategoryDisabled = (
  category: string,
  sectionSettings: Record<string, unknown> = {}
): boolean => isSectionSettingOn(sectionSettings[getCategoryNAField(category.trim())])
